import React from "react";

/**
 * Skeleton générique pour les onglets admin — utilisé pendant le tout
 * premier chargement (cache vide). Beaucoup plus doux à l'œil qu'un
 * simple texte "Chargement…".
 */
export function AdminRowSkeleton({ count = 5 }) {
  return (
    <div className="space-y-2" aria-busy="true" aria-live="polite">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="rounded-2xl bg-white p-3 street-border-thin street-shadow-sm overflow-hidden relative"
        >
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-black/5 skel" />
            <div className="flex-1 space-y-2">
              <div className="h-3 w-1/2 rounded bg-black/5 skel" />
              <div className="h-3 w-1/3 rounded bg-black/5 skel" />
            </div>
            <div className="h-6 w-16 rounded-lg bg-black/5 skel" />
          </div>
        </div>
      ))}
      <style>{`
        .skel {
          position: relative;
          overflow: hidden;
        }
        .skel::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(255,255,255,0.6) 50%,
            transparent 100%
          );
          animation: skel-shimmer 1.4s linear infinite;
        }
        @keyframes skel-shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}

export function AdminStatSkeleton({ count = 2 }) {
  return (
    <div className={`grid grid-cols-${count} gap-2 mb-3`} aria-busy="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-2xl bg-white p-4 street-border-thin street-shadow-sm">
          <div className="h-3 w-1/2 rounded bg-black/5 skel" />
          <div className="h-6 w-16 mt-2 rounded bg-black/5 skel" />
        </div>
      ))}
    </div>
  );
}

export default AdminRowSkeleton;
